import { render, staticRenderFns } from "./fangyiType.vue?vue&type=template&id=2c29bbaa"
import script from "./fangyiType.vue?vue&type=script&lang=js"
export * from "./fangyiType.vue?vue&type=script&lang=js"
import style0 from "./fangyiType.vue?vue&type=style&index=0&id=2c29bbaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports